import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "@/lib/utils";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn("relative flex w-full touch-none select-none items-center", className)}
    {...props}
  >
    <SliderPrimitive.Track className="absolute h-[1.5px] w-full grow overflow-hidden rounded-full bg-[#E3E6EB]">
      <SliderPrimitive.Range className="absolute h-full bg-[#FFE283]" />
      <span
        className="absolute h-full bg-[#FF7274]"
        style={{
          left: `${(props.value ?? props.defaultValue)?.[1] ?? 0}%`,
          right: "0%",
        }}
      ></span>
    </SliderPrimitive.Track>

    {(props.value ?? props.defaultValue)?.map((_, index) => (
      <SliderPrimitive.Thumb
        key={index}
        className="cursor-grab block h-4 w-4 rounded-full border border-[#C8CFDB] bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
      />
    ))}
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
